import {remCalc} from '../../_utils'

export default {
    baseStyle: ({isPageMultiSelect}: {isPageMultiSelect: boolean}) => ({
        '.sv-components-column.sv-components-column--expandable': {
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
        },
        '.sd-body.sd-body--static': {
            display: 'flex',
            width: '100%',
            layerStyle: 'full-width',
        },
        '.sd-page.sd-body__page': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            margin: {
                base: 'small.base',
                lg: `${remCalc(80)} ${remCalc(16)}`,
                xl: `${remCalc(80)} 0`,
            },
        },
        '.sd-imagepicker__item.sd-imagepicker__item--inline': {
            border: 'large',
            borderStyle: 'solid',
            borderColor: 'border.light',
            borderRadius: ['large.base', 'large.md', 'large.lg'],
            _hover: {
                borderColor: {base: 'border.light', lg: 'border.dark'},
            },
        },
        '.sd-imagepicker__item.sd-imagepicker__item--inline.sd-imagepicker__item--checked': {
            border: 'large',
            borderStyle: 'solid',
            borderColor: 'border.dark',
            borderRadius: ['large.base', 'large.md', 'large.lg'],
        },
        '.sd-imagepicker__item.sd-imagepicker__item--inline label.sd-imagepicker__label input[type="radio"]':
            {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: remCalc(40),
                height: remCalc(40),
                appearance: 'none',
                transform: 'rotate(-90deg)',
                position: 'relative',
                '&:before': {
                    content: '""',
                    color: 'text.default',
                    margin: '0 auto',
                    border: 'small',
                    borderStyle: 'solid',
                    borderWidth: {
                        base: `0 ${remCalc(2)} ${remCalc(2)} 0`,
                        sm: `0 ${remCalc(2)} ${remCalc(11)} 0`,
                        md: `0 ${remCalc(2)} ${remCalc(12)} 0`,
                        lg: `0 ${remCalc(2)} ${remCalc(14)} 0`,
                    },
                    transform: 'rotate(-45deg)',
                    height: remCalc(16),
                    cursor: 'pointer',
                    borderRadius: remCalc(2),
                },
                '&:after': {
                    content: '""',
                    color: 'text.default',
                    margin: '0 auto',
                    border: 'small',
                    borderStyle: 'solid',
                    borderWidth: {
                        base: `0 ${remCalc(4)} ${remCalc(2)} 0`,
                        sm: `0 ${remCalc(14)} ${remCalc(2)} 0`,
                        md: `0 ${remCalc(14)} ${remCalc(2)} 0`,
                        lg: `0 ${remCalc(12)} ${remCalc(2)} 0`,
                    },
                    transform: 'rotate(-45deg)',
                    width: remCalc(16),
                    cursor: 'pointer',
                    borderRadius: remCalc(2),
                },
            },
        '.sd-imagepicker__item.sd-imagepicker__item--inline.sd-imagepicker__item--checked label.sd-imagepicker__label input[type="checkbox"]':
            {
                width: remCalc(24),
                height: remCalc(24),
                appearance: 'none',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.dark',
                borderRadius: 'small.base',
                '&:after': {
                    content: '""',
                    color: 'text.default',
                    margin: '0 auto',
                    border: 'medium',
                    borderStyle: 'solid',
                    borderColor: 'border.dark',
                    borderWidth: `0 ${remCalc(1)} ${remCalc(1)} 0`,
                    transform: 'rotate(45deg)',
                    height: remCalc(15),
                    width: remCalc(7),
                },
            },
        '.sd-row.sd-clearfix.sd-page__row': {width: '100%'},
        '.sd-title.sd-page__title': {display: 'none'},
        '.sd-question__header.sd-element__header': {display: 'none'},
        'span.sd-imagepicker__check-decorator': {display: 'none'},
        'legend.sv-hidden': {display: 'none'},
        'input.sd-imagepicker__control': {
            display: 'flex',
            marginRight: remCalc(32),
            width: remCalc(24),
            height: remCalc(24),
        },
        '.sd-imagepicker__image-container': {
            display: 'flex',
            maxWidth: isPageMultiSelect
                ? {base: remCalc(80), lg: remCalc(120)}
                : {base: remCalc(100), lg: remCalc(170)},
            minWidth: isPageMultiSelect
                ? {base: remCalc(80), lg: remCalc(120)}
                : {base: remCalc(100), lg: remCalc(170)},
            height: 'auto',
            minHeight: isPageMultiSelect ? remCalc(80) : remCalc(100),
            margin: isPageMultiSelect
                ? {
                      base: `${remCalc(22)} ${remCalc(24)} ${remCalc(22)} ${remCalc(22)}`,
                      lg: `${remCalc(22)} ${remCalc(24)} ${remCalc(24)} ${remCalc(32)}`,
                  }
                : {
                      base: remCalc(12),
                      lg: `${remCalc(22)} ${remCalc(80)} ${remCalc(22)} ${remCalc(24)}`,
                  },
        },
        'img.sd-imagepicker__image': {
            width: '100%',
            objectFit: 'cover !important',
            aspectRatio: '1 / 1',
        },
        '.sd-imagepicker__item-decorator': {
            display: 'flex',
            alignItems: 'center',
        },
        'span.sd-imagepicker__text': {
            display: 'flex',
            flexDirection: 'column',
            textStyle: isPageMultiSelect
                ? 'head-xsmall'
                : {base: 'head-xsmall', md: 'head-small', lg: 'head-medium'},
            fontWeight: 'medium',
            gap: 'xsmall.base',
        },
        '.sd-imagepicker__description': {
            textStyle: {base: 'body-xxsmall', md: 'body-small', lg: 'body-large'},
            fontWeight: 'normal',
            width: '100%',
            maxW: remCalc(642),
        },
        'fieldset.sd-selectbase.sd-imagepicker': {
            display: isPageMultiSelect ? 'grid' : 'flex',
            gridTemplateColumns: isPageMultiSelect
                ? {base: 'repeat(1, 1fr)', lg: 'repeat(2, 1fr)'}
                : 'unset',
            flexDirection: 'column',
            gap: 'medium.base',
        },
        'label.sd-imagepicker__label': {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row-reverse',
            justifyContent: 'space-between',
            background: 'background.default',
            borderRadius: ['large.base', 'large.md', 'large.lg'],
            cursor: 'pointer',
            width: '100%',
        },
        '.sd-completedpage': {
            padding: remCalc(80),
            display: 'none',
        },
    }),
}
